import React from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { FaSearchPlus } from "react-icons/fa";
import { usePopperTooltip } from "react-popper-tooltip";
import "react-popper-tooltip/dist/styles.css";

export const EyeIcon = ({ isShown, onClick, deploymentId }: { isShown: boolean; onClick: () => void; deploymentId: string }) => {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip({ placement: "top" });

  return (
    <div ref={setTriggerRef} className="relative ml-2">
      <button
        onClick={onClick}
        className="focus:outline-none"
        data-testid={`toggle-${deploymentId}`}
      >
        {isShown ? (
          <FaEye
            className="mt-0.5 text-blue-500"
            size={18}
            data-testid={`eye-icon-shown-${deploymentId}`}
          />
        ) : (
          <FaEyeSlash
            className="mt-0.5 text-gray-400"
            size={18}
            data-testid={`eye-icon-hidden-${deploymentId}`}
          />
        )}
      </button>
      {visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({ className: "tooltip-container" })}
        >
          <div {...getArrowProps({ className: "tooltip-arrow" })} />
          <p>{isShown ? "Hide" : "Show"}</p>
        </div>
      )}
    </div>
  );
};

export const SearchPlusIcon = ({ onClick }: { onClick: () => void }) => {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip({ placement: "top" });

  return (
    <div ref={setTriggerRef} className="relative">
      <button onClick={onClick} className="focus:outline-none">
        <FaSearchPlus className="mt-[3px] text-blue-500" />
      </button>
      {visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({ className: "tooltip-container" })}
        >
          <div {...getArrowProps({ className: "tooltip-arrow" })} />
          <p>Focus</p>
        </div>
      )}
    </div>
  );
};
